import styled from 'styled-components';

export const WrapperPreguntaEncuestaSmileys = styled.div`
  .smileysContainer {
    display: flex;
  }

  .smiley {
    width: 50px;
    height: 50px;
    cursor: pointer;
  }

  .smileyClickeado {
    width: 50px;
    height: 50px;
    cursor: auto;
  }

  .smileyTexto {
    font-size: 13px;
    color: #5a5a5a;
  }

  @media (max-width: 426px) {
    .smiley {
      width: 40px;
      height: 40px;
    }
  
    .smileyClickeado {
      width: 40px;
      height: 40px;
    }
  
    .smileyTexto {
      font-size: 12px;
    }
  }
`;

export default WrapperPreguntaEncuestaSmileys;
